import { T } from '@tolgee/react';
import React from 'react';
import styled from 'styled-components';

import theme from '../../../assets/theme';
import { zIndexes } from '../../../utils/zIndexes';
import StrengthGeneratingLoader from '../../_molecules/StrengthGeneratingLoader/StrengthGeneratingLoader';

interface GreatPicksGeneratingOverlayProps {
  visible: boolean;
  onSkip: () => void;
}

const GreatPicksGeneratingOverlay: React.FC<GreatPicksGeneratingOverlayProps> = ({
  visible,
  onSkip,
}) => {
  if (!visible) return null;

  return (
    <OverlayContainer>
      <Backdrop />
      <ContentContainer>
        <StrengthGeneratingLoader
          headline={
            <T keyName="generatingGreatPicks" defaultValue="Generating great picks" />
          }
          subtitle={
            <T
              keyName="pickingBestExamplesToHighlight"
              defaultValue="Picking the best examples to highlight"
            />
          }
        />
      </ContentContainer>
      <SkipButton type="button" onClick={onSkip}>
        <T keyName="Skip" defaultValue="Skip" />
      </SkipButton>
    </OverlayContainer>
  );
};

const OverlayContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${zIndexes('AI_FEEDBACK_OVERLAY')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Backdrop = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${theme.colors.blackPure};
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

const SkipButton = styled.button`
  position: absolute;
  bottom: 32px;
  right: 32px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.1);
  color: ${theme.colors.white};
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover,
  &:focus {
    background: rgba(255, 255, 255, 0.2);
    outline: none;
  }
`;

export default GreatPicksGeneratingOverlay;
